import { render, staticRenderFns } from "./SelectorCard.vue?vue&type=template&id=37c3f21f"
import script from "./SelectorCard.vue?vue&type=script&lang=js"
export * from "./SelectorCard.vue?vue&type=script&lang=js"
import style0 from "./SelectorCard.vue?vue&type=style&index=0&id=37c3f21f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports